import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {store  } from "./Features/Store";
import { Provider } from 'react-redux';
import ProgressProvider  from './ContextProvider/ProgressContext'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ProgressProvider>
        <App />
      </ProgressProvider>
    </Provider>
  </React.StrictMode>
);


